"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemStatus = void 0;
var ItemStatus;
(function (ItemStatus) {
    ItemStatus["available"] = "available";
    ItemStatus["inCart"] = "inCart";
    ItemStatus["sold"] = "sold";
    ItemStatus["onTheWay"] = "onTheWay";
    ItemStatus["arrivedToCustomer"] = "arrivedToCustomer";
})(ItemStatus || (exports.ItemStatus = ItemStatus = {}));
